import {
    getElement,
    getUID,
    getSelectorFromElement,
    getElementFromSelector,
    getTransitionDurationFromElement,
    triggerTransitionEnd,
    isElement,
    typeCheckConfig,
    isVisible,
    isDisabled,
    findShadowRoot,
    noop,
    getNextActiveElement,
    reflow,
    getjQuery,
    onDOMContentLoaded,
    isRTL,
    defineJQueryPlugin,
    execute,
    executeAfterTransition,
  } from './bootstrap/util/';

/* -------------------------------------------------------------------------- */
/* Navbar                                                                     */
/* -------------------------------------------------------------------------- */

const menuOpen = document.querySelector('[data-bs-toggle="side-navbar"]');
const menuClose = document.querySelector('.menu-closed');
const mainMenu = document.querySelector('.side-navbar'); 
const html = document.querySelector('html');

function openMenu() {
  
  menuClose.classList.toggle('menu-closed--active');

  mainMenu.classList.toggle('side-navbar--open');

  html.classList.toggle('overflow-hidden');
}

menuOpen.addEventListener('click', function() {
  openMenu();
});

  const items = document.querySelectorAll('.sidebar li');
    const sections = document.querySelectorAll('.section');

    // Scrollspy: update active based on scroll position
    window.addEventListener('scroll', () => {
      const scrollPos = window.scrollY + window.innerHeight * 0.25; 
      // offset so change happens a bit before the section top

      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const top = window.scrollY + rect.top;

        if (scrollPos >= top && scrollPos < top + section.offsetHeight) {
          const id = section.getAttribute('id');
          items.forEach(item => {
            item.classList.toggle('active', item.getAttribute('data-target') === id);
          });
        }
      });
    });

    // Clicking menu scrolls to section
    items.forEach(item => {
      item.addEventListener('click', () => {
        const targetId = item.getAttribute('data-target');
        const targetSection = document.getElementById(targetId);
        if (targetSection) {
          window.scrollTo({
            top: targetSection.offsetTop - 20, // adjust offset if needed
            behavior: 'smooth'
          });
        }
      });
    });

    // On load, trigger scrollspy once so the correct item is active if page loaded scrolled
    window.dispatchEvent(new Event('scroll'));

   
     // Tabs
    const tabButtons = document.querySelectorAll('.tab-buttons button');
    const tabContents = document.querySelectorAll('.tab-content');
    tabButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        tabButtons.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));
        btn.classList.add('active');
        document.getElementById(btn.dataset.tab).classList.add('active');
      });
    });

    // Accordion
    document.querySelectorAll('.accordion__button').forEach(button => {
      button.addEventListener('click', () => {
        const panel = button.nextElementSibling;
        const isActive = button.classList.contains('active');
        // close all accordions in same tab
        const parentAccordion = button.closest('.accordion');
        parentAccordion.querySelectorAll('.accordion__button').forEach(b => {
          b.classList.remove('active');
          b.nextElementSibling.classList.remove('active');
        });
        // open clicked one if it was closed
        if (!isActive) {
          button.classList.add('active');
          panel.classList.add('active');
        }
      });
    });